import React from 'react';

// material components
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
} from '@material-ui/core';

// constants
import {
  DASHBOARD_TOOLBAR_TITLE,
  POINTS_COLUMN,
  POINTS_VISIBLE_ROLES,
} from './constants';

// redux
import withShipment from '../../withShipment';
import {
  userInfoSelector,
  onlineEmployeesSelector,
} from '../../redux/selectors/auth';

import { updateUserInfo, getOnlineEmployees } from '../../redux/actions/auth';
import {
  pendingCustomerSelector,
  pointsCustomerSelector,
  rulesSelector,
} from '../../redux/selectors/settings';
import { listRules } from '../../redux/actions/settings';
import compressTicketPhoto from '../../components/ticketOut/compressTicketPhoto';
import '../../components/ticketOut/TicketOut.css';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';

import PropTypes from 'prop-types';

import ErrorFeedbackBar from '../../components/global/ErrorFeedbackBar';
import FeedbackBar from '../../components/feedbackBar/FeedbackBar';

import CustomToolbar from '../../components/global/CustomToolbar';
import RefreshIcon from '@material-ui/icons/Refresh';
import {
  HourglassEmptyTwoTone,
  People,
  AttachMoney,
  Person,
  DesktopWindows,
  AccessTime,
  Search as SearchIcon,
  DeleteOutline,
  Stars,
} from '@material-ui/icons';
import styles from './DashboardFinal.module.css';
import TableCell from '@material-ui/core/TableCell';
import {
  deleteCustomerPending,
  getPointHistory,
  listCustomerPending,
  listCustomerPoints,
  setCustomerTicket,
} from '../../redux/actions/customer';
import Utils from '../../components/Utils/Utils';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { BACK } from '../../components/reading/masterReading/constants';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SessionReportPdf from '../../components/global/SessionReportPdf';
import { refreshSelector } from '../../redux/selectors/ticketOut';
import { customerPointHistorySelector } from '../../redux/selectors/customer';

class DashboardFinal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: new Date(),
      isPreview: false,
      searchText: '',
      customerPoints: [],
      customerPending: [],
      editPending: null,
      //report
      reportTrigger: 0,
      // Local feedback bar for report errors — same shape Transaction,
      // Bonus, Raffle and Ticket Out use. ErrorFeedbackBar below only
      // renders redux `status`, and a report failure is a local message.
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
      isLoading: true,
      isPreviewMobile: false,
      isMobile: window.matchMedia('(max-width: 800px)').matches,
      //sorting — senior roles see a Points column that defaults to
      //descending so the biggest balances float to the top without
      //requiring a click. Inlined (rather than via a helper) so we
      //don't depend on class-field initialization order inside the
      //constructor.
      order: (props?.userInfo?.authority || []).some((r) =>
        POINTS_VISIBLE_ROLES.includes(r)
      )
        ? 'desc'
        : 'asc',
      orderBy: (props?.userInfo?.authority || []).some((r) =>
        POINTS_VISIBLE_ROLES.includes(r)
      )
        ? 'points'
        : '',
      popperOpen: false,
      anchorEl: null,

      //alert
      isImageZoomed: false,

      // Active tab: 0 = Pending List, 1 = Points List
      activeTab: 0,

      // Redesigned dashboard: filter pill + last-updated stamp
      activeFilter: 'all', // 'all' | 'pending' | 'matched'
      lastUpdatedAt: new Date(),

      // Delete confirmation
      deleteTarget: null, // { kind, row } or null

      // VIP Match photo capture
      vipPhoto: null,
      vipPhotoPreviewUrl: null,
      vipPhotoError: null,
      isCameraOpen: false,
      cameraFacingMode: 'environment',
      savingTicket: false,

      // Lightbox URL for viewing an existing saved VIP photo at full size
      vipPhotoLightboxUrl: null,
    };

    this.videoRef = React.createRef();
    this.canvasRef = React.createRef();
  }

  componentWillUnmount() {
    this.stopCamera();
    if (this.state.vipPhotoPreviewUrl) {
      URL.revokeObjectURL(this.state.vipPhotoPreviewUrl);
    }
  }

  canSeePoints = () => {
    const auths = this.props.userInfo?.authority || [];
    return POINTS_VISIBLE_ROLES.some((r) => auths.includes(r));
  };

  // Inject the Points column into a base head-cells list when the
  // current user is entitled to see it. For the Points list (which
  // already has a 'ticket' / Machine column) the Points column goes
  // immediately after Machine. For the Pending list (no Machine column)
  // it's appended to the end.
  withPointsColumn = (baseCells) => {
    if (!this.canSeePoints()) return baseCells;
    const ticketIdx = baseCells.findIndex((c) => c.id === 'ticket');
    if (ticketIdx === -1) {
      return [...baseCells, POINTS_COLUMN];
    }
    return [
      ...baseCells.slice(0, ticketIdx + 1),
      POINTS_COLUMN,
      ...baseCells.slice(ticketIdx + 1),
    ];
  };

  handleTabChange = (_event, newValue) => {
    this.setState({ activeTab: newValue });
  };

  componentDidMount() {
    this.refreshComponent();
    if (this.props.userInfo?.selectedLocationId) {
      this.props.listRules({
        locationId: this.props.userInfo.selectedLocationId,
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.refresh !== this.props.refresh) {
      this.refreshComponent();
    }

    if (prevProps.customerPending !== this.props.customerPending) {
      this.setState({
        customerPending: this.props.customerPending,
      });
    }

    if (prevProps.customerPoints !== this.props.customerPoints) {
      this.setState({
        customerPoints: this.props.customerPoints,
      });
    }
  }

  handleRequestSort = (property) => {
    const isAscending =
      this.state.orderBy === property && this.state.order === 'asc';
    this.setState({
      order: isAscending ? 'desc' : 'asc',
      orderBy: property,
    });
  };

  sortedData = () => {
    const { customerPending } = this.props;
    const { order, orderBy } = this.state;

    if (!orderBy) return customerPending; // No sorting applied initially

    return [...customerPending].sort((a, b) => {
      let valA, valB;

      if (orderBy === 'firstName' || orderBy === 'lastName') {
        valA = a.customer?.[orderBy] ?? '';
        valB = b.customer?.[orderBy] ?? '';
      } else {
        valA = a[orderBy] ?? '';
        valB = b[orderBy] ?? '';
      }

      // Points are stored on the pending record as strings (they come
      // from a String field on the CustomerPending embed). Coerce to
      // numeric so "90" sorts below "100" instead of above it.
      if (orderBy === 'points') {
        valA = Number(valA) || 0;
        valB = Number(valB) || 0;
      } else {
        if (typeof valA === 'string') valA = valA.toLowerCase();
        if (typeof valB === 'string') valB = valB.toLowerCase();
      }

      if (valA < valB) return order === 'asc' ? -1 : 1;
      if (valA > valB) return order === 'asc' ? 1 : -1;
      return 0;
    });
  };

  sortedPointsData = () => {
    const { customerPoints } = this.props;
    const { order, orderBy } = this.state;

    if (!orderBy) return customerPoints; // No sorting applied initially

    return [...customerPoints].sort((a, b) => {
      let valA, valB;

      if (orderBy === 'firstName' || orderBy === 'lastName') {
        valA = a.customer?.[orderBy] ?? '';
        valB = b.customer?.[orderBy] ?? '';
      } else {
        valA = a[orderBy] ?? '';
        valB = b[orderBy] ?? '';
      }

      // Points are stored on the pending record as strings (they come
      // from a String field on the CustomerPending embed). Coerce to
      // numeric so "90" sorts below "100" instead of above it.
      if (orderBy === 'points') {
        valA = Number(valA) || 0;
        valB = Number(valB) || 0;
      } else {
        if (typeof valA === 'string') valA = valA.toLowerCase();
        if (typeof valB === 'string') valB = valB.toLowerCase();
      }

      if (valA < valB) return order === 'asc' ? -1 : 1;
      if (valA > valB) return order === 'asc' ? 1 : -1;
      return 0;
    });
  };

  formatTodayDate = (date) => {
    const options = {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(date);

    // Extract year, month, and day parts
    const year = parts.find((part) => part.type === 'year').value;
    const month = parts.find((part) => part.type === 'month').value;
    const day = parts.find((part) => part.type === 'day').value;

    // Format as YYYY-MM-DD
    return `${year}-${month}-${day}`;
  };

  handleImageLoad = () => {
    this.setState({ isLoading: false });
  };

  handleImageError = () => {
    this.setState({ isLoading: false }); // Optionally handle errors like showing a fallback image
  };

  hasCustomerAccess = () => {
    const auths = this.props.userInfo?.authority || [];
    return auths.includes('ROLE_CUSTOMER');
  };

  refreshComponent = () => {
    // Both endpoints require ROLE_CUSTOMER on the backend. Skipping
    // them for users without customer access (e.g. Reading Guy) avoids
    // a 401/403 that would trip AuthUtil's auto-logout on mount.
    if (!this.hasCustomerAccess()) return;

    this.setState({ lastUpdatedAt: new Date() });

    this.props.listCustomerPending(
      this.formatTodayDate(this.state.selectedDate),
      this.props.userInfo.selectedLocationId
    );
    this.props.listCustomerPoints(
      this.props.userInfo.userId,
      this.formatTodayDate(this.state.selectedDate),
      this.props.userInfo.selectedLocationId
    );

    this.props.getOnlineEmployees({
      locationId: this.props.userInfo.selectedLocationId,
    });
  };

  handleDateChange = (date) => {
    this.setState(
      {
        selectedDate: date,
      },
      () => {
        if (date && !isNaN(date.getTime())) {
          //Only send request when the date is proper
          this.refreshComponent();
        }
      }
    );
  };

  renderCellContent = (headCell, row, customer) => {
    // Logic to determine content based on headCell.id
    switch (headCell.id) {
      // case 'tagId':
      //   return customer[headCell.id] || customer[headCell.id];
      case 'picture':
        const customerFiles = customer?.files
          ? JSON.parse(customer.files)
          : null;
        return (
          <TableCell className="table-cell-left">
            {this.state.isLoading && (
              <div className="loading-indicator">
                <CircularProgress />
              </div>
            )}
            <img
              src={customerFiles?.localURL}
              alt="Customer"
              className="responsive-image-customerr"
              onLoad={this.handleImageLoad}
              onError={this.handleImageError}
            />
          </TableCell>
        );
      case 'firstName':
        return customer[headCell.id] || customer[headCell.id];
      case 'lastName':
        return customer[headCell.id] || customer[headCell.id];
      case 'signInTime':
        return Utils.convertTo12HourFormat(
          customer[headCell.id] || row[headCell.id]
        );
      case 'points': {
        const raw = row.points ?? customer.points ?? 0;
        const n = Number(raw) || 0;
        return (
          <span style={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
            {n.toLocaleString()}
          </span>
        );
      }
      default:
        return null;
    }
  };

  renderCellPointsContent = (headCell, row, customer) => {
    // Logic to determine content based on headCell.id
    switch (headCell.id) {
      // case 'tagId':
      //   return customer[headCell.id] || customer[headCell.id];
      case 'picture':
        const customerFiles = customer?.files
          ? JSON.parse(customer.files)
          : null;
        return (
          <TableCell className="table-cell-left">
            {this.state.isLoading && (
              <div className="loading-indicator">
                <CircularProgress />
              </div>
            )}
            <img
              src={customerFiles?.localURL}
              alt="Customer"
              className="responsive-image-customerr"
              onLoad={this.handleImageLoad}
              onError={this.handleImageError}
            />
          </TableCell>
        );
      case 'firstName':
        return customer[headCell.id] || customer[headCell.id];
      case 'lastName':
        return customer[headCell.id] || customer[headCell.id];
      case 'finalSignIn':
        return customer[headCell.id] || row[headCell.id];
      case 'signInTime':
        return Utils.convertTo12HourFormat(
          customer[headCell.id] || row[headCell.id]
        );
      case 'points': {
        const raw = row.points ?? customer.points ?? 0;
        const n = Number(raw) || 0;
        return (
          <span style={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
            {n.toLocaleString()}
          </span>
        );
      }
      case 'ticket':
        return customer[headCell.id] || row[headCell.id];
      default:
        return row[headCell.id];
    }
  };

  handleMachineChange = (event) => {
    const { value } = event.target;

    const reg = /^[0-9\b]+$/; // Regex to allow only digits and empty input (for clearing the field)

    if (value === '' || reg.test(value)) {
      this.setState((prevState) => ({
        editPending: {
          ...prevState.editPending,
          ticket: value.toString(),
        },
      }));
    }
  };

  handlePointsChange = (event) => {
    const value = event.target.value;
    // Ensure that only numeric values are allowed and handle input correctly
    if (!isNaN(value) && value >= 0) {
      this.setState({ points: Number(value) });
    }
  };

  handleEditRow = (customer) => {
    this.clearVipPhoto();
    if (this.state.isMobile) {
      this.setState({ isPreviewMobile: true, editPending: customer }, () => {
        this.props.getPointHistory({
          customerId: this.state.editPending.customer.customerId,
        });
      });
    } else {
      this.setState({ isPreview: true, editPending: customer }, () => {
        this.props.getPointHistory({
          customerId: this.state.editPending.customer.customerId,
        });
      });
    }
  };

  // ── VIP Match photo gate ────────────────────────────────────────────────
  getVipRule = () => {
    const rules = this.props.rules;
    return Array.isArray(rules) && rules.length > 0 ? rules[0] : null;
  };

  isVipPhotoRequired = () => {
    const rule = this.getVipRule();
    if (!rule || rule.vipMatchEnabled !== true) return false;
    const threshold = Number(rule.vipMatchPoints || 0);
    if (!threshold) return false;
    const points = Number(this.state.editPending?.points || 0);
    return points >= threshold;
  };

  stopCamera = () => {
    const stream = this.videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    if (this.videoRef.current) this.videoRef.current.srcObject = null;
    this.setState({ isCameraOpen: false });
  };

  startCamera = async () => {
    try {
      const existing = this.videoRef.current?.srcObject;
      if (existing) {
        existing.getTracks().forEach((track) => track.stop());
      }

      const constraints = {
        video: {
          facingMode: { ideal: this.state.cameraFacingMode },
          width: { min: 1024, ideal: 1920, max: 3840 },
          height: { min: 720, ideal: 1080, max: 2160 },
          frameRate: { ideal: 60 },
        },
        audio: false,
      };

      const stream = await navigator.mediaDevices.getUserMedia(constraints);

      const track = stream.getVideoTracks()[0];
      const capabilities = track.getCapabilities ? track.getCapabilities() : {};
      if (capabilities.focusMode?.includes('continuous')) {
        await track.applyConstraints({
          advanced: [{ focusMode: 'continuous' }],
        });
      }

      this.setState({ isCameraOpen: true, vipPhotoError: null });
      if (this.videoRef.current) {
        this.videoRef.current.srcObject = stream;
      }
    } catch (err) {
      alert('Camera access error: ' + err.message);
    }
  };

  switchCamera = () => {
    const nextFacingMode =
      this.state.cameraFacingMode === 'environment' ? 'user' : 'environment';
    this.setState({ cameraFacingMode: nextFacingMode }, () => {
      if (this.state.isCameraOpen) this.startCamera();
    });
  };

  handleOpenCamera = () => {
    if (!this.state.isCameraOpen) this.startCamera();
  };

  capturePhoto = () => {
    const canvas = this.canvasRef.current;
    const video = this.videoRef.current;
    if (!canvas || !video) return;

    const vWidth = video.videoWidth;
    const vHeight = video.videoHeight;
    const screenAspectRatio = window.innerWidth / window.innerHeight;
    const videoAspectRatio = vWidth / vHeight;

    let sWidth, sHeight, sx, sy;
    if (videoAspectRatio > screenAspectRatio) {
      sWidth = vHeight * screenAspectRatio;
      sHeight = vHeight;
      sx = (vWidth - sWidth) / 2;
      sy = 0;
    } else {
      sWidth = vWidth;
      sHeight = vWidth / screenAspectRatio;
      sx = 0;
      sy = (vHeight - sHeight) / 2;
    }

    canvas.width = sWidth;
    canvas.height = sHeight;

    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(video, sx, sy, sWidth, sHeight, 0, 0, sWidth, sHeight);

    const imageURL = canvas.toDataURL('image/jpeg', 0.8);
    this.stopCamera();
    this.handleCapturedDataUrl(imageURL);
  };

  handleCapturedDataUrl = async (dataUrl) => {
    try {
      const res = await fetch(dataUrl);
      const blob = await res.blob();
      const file = new File([blob], `vip-${Date.now()}.jpeg`, {
        type: 'image/jpeg',
      });
      const compressed = await compressTicketPhoto(file);
      if (this.state.vipPhotoPreviewUrl) {
        URL.revokeObjectURL(this.state.vipPhotoPreviewUrl);
      }
      this.setState({
        vipPhoto: compressed,
        vipPhotoPreviewUrl: URL.createObjectURL(compressed),
        vipPhotoError: null,
      });
    } catch (message) {
      this.setState({
        vipPhoto: null,
        vipPhotoPreviewUrl: null,
        vipPhotoError:
          typeof message === 'string'
            ? message
            : 'Could not process the photo, please retake.',
      });
    }
  };

  clearVipPhoto = () => {
    this.stopCamera();
    if (this.state.vipPhotoPreviewUrl) {
      URL.revokeObjectURL(this.state.vipPhotoPreviewUrl);
    }
    this.setState({
      vipPhoto: null,
      vipPhotoPreviewUrl: null,
      vipPhotoError: null,
    });
  };

  openVipPhotoLightbox = (url) => (event) => {
    if (event) event.stopPropagation();
    if (!url) return;
    this.setState({ vipPhotoLightboxUrl: url });
  };

  closeVipPhotoLightbox = () => {
    this.setState({ vipPhotoLightboxUrl: null });
  };

  handleEditPointsRow = (customer) => {
    this.clearVipPhoto();
    if (this.state.isMobile) {
      this.setState({ isPreviewMobile: true, editPending: customer }, () => {
        this.props.getPointHistory({
          customerId: this.state.editPending.customer.customerId,
        });
      });
    } else {
      this.setState({ isPreview: true, editPending: customer }, () => {
        this.props.getPointHistory({
          customerId: this.state.editPending.customer.customerId,
        });
      });
    }
  };

  handleDeleteCustomerPending = (intent, pendingId) => {
    this.props.deleteCustomerPending(
      intent,
      pendingId,
      this.formatTodayDate(this.state.selectedDate),
      this.props.userInfo.selectedLocationId
    );
  };

  // Open the confirmation dialog for a row. The actual delete is fired
  // from the dialog's confirm action so the user has a chance to back out.
  handleRowDelete = (entry) => (event) => {
    event.stopPropagation();
    this.setState({ deleteTarget: entry });
  };

  closeDeleteDialog = () => this.setState({ deleteTarget: null });

  confirmDelete = () => {
    const target = this.state.deleteTarget;
    if (!target) return;
    const { kind, row } = target;
    const intent = kind === 'pending' ? 'pending' : 'matched';
    this.handleDeleteCustomerPending(intent, row.pendingId);
    this.setState({ deleteTarget: null });
  };

  saveTicket(editPending) {
    if (!editPending.ticket) return;
    // VIP photo is required only if the threshold demands one AND the
    // record doesn't already have a saved photo on file AND no new
    // photo was captured during this edit.
    if (
      this.isVipPhotoRequired() &&
      !editPending.customer?.vipPhotoUrl &&
      !this.state.vipPhoto
    ) {
      return;
    }
    if (this.state.savingTicket) return;

    this.setState({ savingTicket: true });
    this.handleTicketUpdate(
      this.props.userInfo.userId,
      editPending.pendingId,
      editPending.ticket,
      this.state.vipPhoto
    );
  }

  handleTicketUpdate = (userId, pendingId, ticket, photo) => {
    const callback = (error, response) => {
      this.setState({ savingTicket: false });
      if (error) {
        console.error('Failed to update ticket:', error);
        return;
      }
      this.clearVipPhoto();
      if (this.state.isMobile) {
        this.setState({ isPreviewMobile: false });
      } else {
        this.setState({ isPreview: false });
      }
      this.refreshComponent();
    };

    this.props.setCustomerTicket(userId, pendingId, ticket, callback, photo);
  };

  calculateTotalPoints = () => {
    const { customerPoints } = this.props;
    if (!customerPoints) return 0;
    return customerPoints.reduce(
      (total, pointEntry) => total + parseFloat(pointEntry.points || 0),
      0
    );
  };

  calculateGivenPointsCount = () => {
    const { customerPoints } = this.props;
    if (!customerPoints) return 0;
    return customerPoints.length; // Number of entries in customerPoints array
  };

  // Generates the new employee-session points PDF for this employee's latest
  // shift (bumping reportTrigger fires SessionReportPdf).
  fetchPdf = () => {
    this.setState((s) => ({ reportTrigger: s.reportTrigger + 1 }));
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState({
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
    });
  };

  handleReportError = (message) => {
    // Was a window.alert, which blocks the page and looks nothing like the
    // rest of the app. Every other screen with a View Report button
    // (Transaction, Bonus, Raffle, Ticket Out) surfaces the same failure
    // through the feedback bar, so this does too.
    if (message) this.openFeedbackBar('error', message);
  };

  // ---------- Redesigned dashboard helpers ----------

  // Server stores `finalSignIn` as "(EmployeeName) EEEE d: hh:mm a"
  // (CustomerService.groovy → "EEEE d: hh:mm a"), e.g.
  // "(Daniel) Monday 27: 12:50 PM". For the dashboard, render Match
  // Info as: Machine N • <time> • By <employee>. We drop the day/date
  // and keep only the trailing "h:mm AM/PM" so the row stays scannable.
  parseFinalSignIn = (raw) => {
    if (!raw) return { employee: null, time: null };
    let employee = null;
    let rest = String(raw).trim();
    const m = rest.match(/^\(([^)]+)\)\s*(.*)$/);
    if (m) {
      employee = m[1].trim();
      rest = m[2].trim();
    }
    const t = rest.match(/(\d{1,2}:\d{2}\s*[AP]M)\s*$/i);
    return { employee, time: t ? t[1].toUpperCase() : rest || null };
  };

  getAvatarUrl = (customer) => {
    try {
      const f = customer?.files ? JSON.parse(customer.files) : null;
      return f?.localURL || null;
    } catch (_) {
      return null;
    }
  };

  getInitials = (customer) => {
    const f = (customer?.firstName || '').trim();
    const l = (customer?.lastName || '').trim();
    return `${f.charAt(0)}${l.charAt(0)}`.toUpperCase() || '?';
  };

  // Combined feed: pending rows first (always sorted to the top per
  // spec), then matched rows. Each entry carries its `kind` so the
  // renderer can pick row state + match-info shape without re-checking.
  buildCombinedRows = () => {
    const pending = (this.props.customerPending || []).map((r) => ({
      kind: 'pending',
      row: r,
    }));
    const matched = (this.props.customerPoints || []).map((r) => ({
      kind: 'matched',
      row: r,
    }));
    return [...pending, ...matched];
  };

  applyFilter = (combined) => {
    const { activeFilter, searchText } = this.state;
    let out = combined;
    if (activeFilter === 'pending')
      out = out.filter((e) => e.kind === 'pending');
    if (activeFilter === 'matched')
      out = out.filter((e) => e.kind === 'matched');
    if (searchText && searchText.trim()) {
      const q = searchText.trim().toLowerCase();
      out = out.filter((e) => {
        const c = e.row.customer || {};
        return (
          (c.firstName || '').toLowerCase().includes(q) ||
          (c.lastName || '').toLowerCase().includes(q) ||
          (c.phone || '').toLowerCase().includes(q)
        );
      });
    }
    return out;
  };

  formatLastUpdated = (date) => {
    if (!date) return '';
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  countCustomersToday = () =>
    (this.props.customerPending || []).length +
    (this.props.customerPoints || []).length;

  countEmployeesActive = () => {
    const online = this.props.onlineEmployees;
    return Array.isArray(online) ? online.length : 0;
  };

  formatTotalMatchAmount = () => {
    const n = this.calculateTotalPoints() || 0;
    return `$${Math.round(n).toLocaleString()}`;
  };

  setFilter = (f) => () => this.setState({ activeFilter: f });

  handleSearchChange = (e) => this.setState({ searchText: e.target.value });

  // ---------------------------------------------------

  render() {
    const combinedRows = this.applyFilter(this.buildCombinedRows());

    let headerButtons = [];

    if (this.state.isPreviewMobile) {
      headerButtons.push({
        icon: <KeyboardBackspaceIcon />,
        handler: () => this.setState({ isPreviewMobile: false }),
        title: BACK,
      });
    } else {
      if (!this.state.isMobile) {
        headerButtons.push({
          icon: <VisibilityIcon />,
          handler: () => this.fetchPdf(),
          title: 'View Report',
        });
      }

      headerButtons.push({
        icon: this.props.refreshing ? (
          <HourglassEmptyTwoTone />
        ) : (
          <RefreshIcon />
        ),
        handler: this.refreshComponent,
        title: this.props.refreshing ? 'Refreshing...' : 'Refresh',
        disabled: this.props.refreshing,
      });
    }

    return (
      <>
        <ErrorFeedbackBar />
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />
        {this.state.isPreviewMobile && (
          <CustomToolbar
            title={DASHBOARD_TOOLBAR_TITLE}
            createTitle={'Dashboard'}
            backTitle={'Back To Menu'}
            onClick={() => {}}
            headerButtons={headerButtons}
          />
        )}

        <Dialog
          open={this.state.isPreview}
          onClose={() => this.setState({ isPreview: false })}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle
            style={{
              fontWeight: 'bold',
              fontSize: '18px',
              marginLeft: '24px',
              marginTop: '16px',
            }}
          >
            Customer Information
          </DialogTitle>
          <DialogContent>
            <div className="right-column">
              <div className="rowSpec-two-customer">
                <img
                  src={
                    this.state.editPending?.customer?.files
                      ? JSON.parse(this.state.editPending.customer.files)
                          ?.localURL
                      : null
                  }
                  alt="Customer"
                  className="responsive-image"
                />
                <div>
                  <h4 className="customer-name">
                    {this.state.editPending?.customer.firstName}{' '}
                    {this.state.editPending?.customer.lastName}
                  </h4>

                  <div className="rowSpec-two">
                    <TextField
                      className="input-text-field-dashboard"
                      variant="outlined"
                      label="Points"
                      InputLabelProps={{ shrink: true }}
                      name="points"
                      type="number"
                      value={this.state.editPending?.points}
                      onChange={this.handlePointsChange}
                      disabled={true}
                      inputProps={{ readOnly: true }}
                    />
                  </div>

                  <div className="rowSpec-two" style={{ marginBottom: '16px' }}>
                    <TextField
                      className="input-text-field-dashboard"
                      variant="outlined"
                      label="Machine"
                      InputLabelProps={{ shrink: true }}
                      name="machine"
                      value={this.state.editPending?.ticket || ''}
                      onChange={this.handleMachineChange}
                      type="tel"
                      inputProps={{
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                        min: '0',
                        step: '1',
                      }}
                    />
                  </div>

                  {this.isVipPhotoRequired() && (
                    <div
                      className="photo-required-panel"
                      style={{ margin: '0 0 16px 0', boxSizing: 'border-box' }}
                    >
                      {this.state.editPending?.customer?.vipPhotoUrl &&
                      !this.state.vipPhoto ? (
                        <>
                          <div className="photo-required-header">
                            <PhotoCameraIcon style={{ color: '#059669' }} />
                            <div>
                              <p className="photo-required-title">
                                VIP Photo on File
                              </p>
                              <p className="photo-required-text">
                                A photo was captured for this customer. You can
                                view it or replace it with a new one.
                              </p>
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              gap: 10,
                              marginTop: 12,
                            }}
                          >
                            <Button
                              variant="contained"
                              disableElevation
                              fullWidth
                              startIcon={<VisibilityIcon />}
                              onClick={this.openVipPhotoLightbox(
                                this.state.editPending.customer.vipPhotoUrl
                              )}
                              style={{
                                backgroundColor: '#059669',
                                color: '#fff',
                                textTransform: 'none',
                                fontWeight: 600,
                                borderRadius: 8,
                                padding: '8px 14px',
                              }}
                            >
                              View Photo
                            </Button>
                            <Button
                              variant="outlined"
                              fullWidth
                              startIcon={<PhotoCameraIcon />}
                              onClick={this.handleOpenCamera}
                              style={{
                                color: '#374151',
                                borderColor: '#D1D5DB',
                                textTransform: 'none',
                                fontWeight: 600,
                                borderRadius: 8,
                                padding: '8px 14px',
                              }}
                            >
                              Replace
                            </Button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="photo-required-header">
                            <WarningIcon style={{ color: '#d97706' }} />
                            <div>
                              <p className="photo-required-title">
                                VIP Photo Required
                              </p>
                              <p className="photo-required-text">
                                This customer has{' '}
                                {Number(this.state.editPending?.points || 0)}{' '}
                                points (VIP threshold:{' '}
                                {Number(this.getVipRule()?.vipMatchPoints || 0)}
                                ). A photo is required before the machine can be
                                set.
                              </p>
                            </div>
                          </div>

                          {this.state.vipPhoto ? (
                            <div className="photo-preview-wrap">
                              <img
                                className="photo-preview-img"
                                src={this.state.vipPhotoPreviewUrl}
                                alt="VIP"
                              />
                              <div className="photo-preview-actions">
                                <Button
                                  variant="outlined"
                                  size="small"
                                  startIcon={<PhotoCameraIcon />}
                                  onClick={this.handleOpenCamera}
                                >
                                  Retake
                                </Button>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  style={{
                                    color: '#dc2626',
                                    borderColor: '#fca5a5',
                                  }}
                                  onClick={this.clearVipPhoto}
                                >
                                  Remove
                                </Button>
                              </div>
                            </div>
                          ) : (
                            <Button
                              variant="contained"
                              color="primary"
                              fullWidth
                              startIcon={<PhotoCameraIcon />}
                              onClick={this.handleOpenCamera}
                            >
                              Take Photo
                            </Button>
                          )}
                        </>
                      )}

                      {this.state.vipPhotoError && (
                        <p
                          className="photo-required-text"
                          style={{ color: '#dc2626' }}
                        >
                          {this.state.vipPhotoError}
                        </p>
                      )}
                    </div>
                  )}

                  <div style={{ marginBottom: '16px' }}>
                    <Button
                      className="btn-dashboard"
                      style={{ width: '100%' }}
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={() => this.saveTicket(this.state.editPending)}
                      disabled={
                        !this.state.editPending?.ticket ||
                        this.state.savingTicket ||
                        (this.isVipPhotoRequired() &&
                          !this.state.editPending?.customer?.vipPhotoUrl &&
                          !this.state.vipPhoto)
                      }
                    >
                      {this.state.savingTicket ? 'SAVING...' : 'Set Machine'}
                    </Button>
                  </div>

                  {this.props.customerPointHistory && (
                    <div style={{ marginBottom: '16px' }}>
                      <p>
                        <b>
                          Total Visits: (
                          {this.props.customerPointHistory.totalVisits})
                        </b>
                      </p>
                      <Divider style={{ marginBottom: '16px' }} />
                      <p>
                        <b>
                          Last Visit:{' '}
                          {this.props.customerPointHistory.lastVisit}
                        </b>
                      </p>
                      <Divider style={{ marginBottom: '16px' }} />
                      <p>
                        <b>
                          Registration Date:{' '}
                          {this.props.customerPointHistory.registrationDate}
                        </b>
                      </p>
                      <Divider style={{ marginBottom: '16px' }} />
                    </div>
                  )}

                  <TextField
                    label="Comments"
                    multiline
                    rows={4}
                    variant="outlined"
                    value={this.state.editPending?.customer?.comments || ''}
                    InputProps={{
                      readOnly: true,
                    }}
                    className="comments-field"
                  />

                  <Button
                    style={{ marginBottom: '24px' }}
                    className="btn-close"
                    variant="contained"
                    onClick={() => this.setState({ isPreview: false })}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>

        {/* Delete confirmation dialog — destructive, professional design.
            Shows the customer photo + name so the user verifies who they
            are about to remove before confirming. */}
        <Dialog
          open={Boolean(this.state.deleteTarget)}
          onClose={this.closeDeleteDialog}
          maxWidth="xs"
          fullWidth
          classes={{ paper: styles.deleteDialogPaper }}
        >
          {this.state.deleteTarget &&
            (() => {
              const { kind, row } = this.state.deleteTarget;
              const customer = row.customer || {};
              const fullName =
                `${customer.firstName || ''} ${
                  customer.lastName || ''
                }`.trim() || 'this customer';
              const avatar = this.getAvatarUrl(customer);
              return (
                <>
                  <div className={styles.deleteDialogHead}>
                    <div className={styles.deleteDialogIcon}>
                      <DeleteOutline style={{ fontSize: 26 }} />
                    </div>
                    <DialogTitle
                      disableTypography
                      className={styles.deleteDialogTitle}
                    >
                      Delete entry?
                    </DialogTitle>
                  </div>
                  <DialogContent className={styles.deleteDialogContent}>
                    <div className={styles.deleteDialogCustomer}>
                      {avatar ? (
                        <img
                          src={avatar}
                          alt=""
                          className={styles.deleteDialogAvatar}
                        />
                      ) : (
                        <div className={styles.deleteDialogAvatarFallback}>
                          {this.getInitials(customer)}
                        </div>
                      )}
                      <div className={styles.deleteDialogNameWrap}>
                        <span className={styles.deleteDialogName}>
                          {fullName}
                        </span>
                        <span className={styles.deleteDialogKind}>
                          {kind === 'pending'
                            ? 'Pending entry'
                            : 'Matched entry'}
                        </span>
                      </div>
                    </div>
                    <p className={styles.deleteDialogMessage}>
                      This will remove <strong>{fullName}</strong> from
                      today&apos;s list. This action cannot be undone.
                    </p>
                  </DialogContent>
                  <DialogActions className={styles.deleteDialogActions}>
                    <button
                      type="button"
                      className={styles.deleteDialogCancel}
                      onClick={this.closeDeleteDialog}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className={styles.deleteDialogConfirm}
                      onClick={this.confirmDelete}
                      autoFocus
                    >
                      <DeleteOutline style={{ fontSize: 18 }} />
                      Delete
                    </button>
                  </DialogActions>
                </>
              );
            })()}
        </Dialog>

        {this.state.isPreviewMobile ? (
          <div
            className="right-column"
            style={{
              marginLeft: '16px',
              marginRight: '16px',
              marginBottom: '16px',
            }}
          >
            <h4 className="preview-title">Customer Information</h4>
            <div className="rowSpec-two-customer">
              <img
                src={
                  this.state.editPending?.customer?.files
                    ? JSON.parse(this.state.editPending.customer.files)
                        ?.localURL
                    : null
                }
                alt="Customer"
                // className="image-container"
                style={{
                  width: '100vw',
                  height: '300px',
                  backgroundColor: this.state.capturedImageURL
                    ? 'transparent'
                    : 'gray',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                }}
                className="responsive-image"
              />
              <div>
                <h4 className="customer-name">
                  {this.state.editPending?.customer.firstName}{' '}
                  {this.state.editPending?.customer.lastName}
                </h4>

                <div className="rowSpec-two">
                  <TextField
                    className="input-text-field-dashboard"
                    variant="outlined"
                    label="Points"
                    InputLabelProps={{ shrink: true }}
                    name="points"
                    type="number"
                    value={this.state.editPending?.points}
                    onChange={this.handlePointsChange}
                    disabled={true}
                    inputProps={{ readOnly: true }}
                  />
                </div>

                <div className="rowSpec-two" style={{ marginBottom: '16px' }}>
                  <TextField
                    className="input-text-field-dashboard"
                    variant="outlined"
                    label="Machine"
                    InputLabelProps={{ shrink: true }}
                    name="machine"
                    value={this.state.editPending?.ticket || ''}
                    onChange={this.handleMachineChange}
                    type="tel"
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      min: '0',
                      step: '1',
                    }}
                  />
                </div>

                {this.isVipPhotoRequired() && (
                  <div
                    className="photo-required-panel"
                    style={{ margin: '0 0 16px 0', boxSizing: 'border-box' }}
                  >
                    {this.state.editPending?.customer?.vipPhotoUrl &&
                    !this.state.vipPhoto ? (
                      <>
                        <div className="photo-required-header">
                          <PhotoCameraIcon style={{ color: '#059669' }} />
                          <div>
                            <p className="photo-required-title">
                              VIP Photo on File
                            </p>
                            <p className="photo-required-text">
                              A photo was captured for this customer. You can
                              view it or replace it with a new one.
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            gap: 10,
                            marginTop: 12,
                          }}
                        >
                          <Button
                            variant="contained"
                            disableElevation
                            fullWidth
                            startIcon={<VisibilityIcon />}
                            onClick={this.openVipPhotoLightbox(
                              this.state.editPending.customer.vipPhotoUrl
                            )}
                            style={{
                              backgroundColor: '#059669',
                              color: '#fff',
                              textTransform: 'none',
                              fontWeight: 600,
                              borderRadius: 8,
                              padding: '8px 14px',
                            }}
                          >
                            View Photo
                          </Button>
                          <Button
                            variant="outlined"
                            fullWidth
                            startIcon={<PhotoCameraIcon />}
                            onClick={this.handleOpenCamera}
                            style={{
                              color: '#374151',
                              borderColor: '#D1D5DB',
                              textTransform: 'none',
                              fontWeight: 600,
                              borderRadius: 8,
                              padding: '8px 14px',
                            }}
                          >
                            Replace
                          </Button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="photo-required-header">
                          <WarningIcon style={{ color: '#d97706' }} />
                          <div>
                            <p className="photo-required-title">
                              VIP Photo Required
                            </p>
                            <p className="photo-required-text">
                              This customer has{' '}
                              {Number(this.state.editPending?.points || 0)}{' '}
                              points (VIP threshold:{' '}
                              {Number(this.getVipRule()?.vipMatchPoints || 0)}).
                              A photo is required before the machine can be set.
                            </p>
                          </div>
                        </div>

                        {this.state.vipPhoto ? (
                          <div className="photo-preview-wrap">
                            <img
                              className="photo-preview-img"
                              src={this.state.vipPhotoPreviewUrl}
                              alt="VIP"
                            />
                            <div className="photo-preview-actions">
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<PhotoCameraIcon />}
                                onClick={this.handleOpenCamera}
                              >
                                Retake
                              </Button>
                              <Button
                                variant="outlined"
                                size="small"
                                style={{
                                  color: '#dc2626',
                                  borderColor: '#fca5a5',
                                }}
                                onClick={this.clearVipPhoto}
                              >
                                Remove
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            startIcon={<PhotoCameraIcon />}
                            onClick={this.handleOpenCamera}
                          >
                            Take Photo
                          </Button>
                        )}
                      </>
                    )}

                    {this.state.vipPhotoError && (
                      <p
                        className="photo-required-text"
                        style={{ color: '#dc2626' }}
                      >
                        {this.state.vipPhotoError}
                      </p>
                    )}
                  </div>
                )}

                <div style={{ marginBottom: '16px' }}>
                  <Button
                    className="btn-dashboard"
                    variant="contained"
                    color="primary"
                    onClick={() => this.saveTicket(this.state.editPending)}
                    disabled={
                      !this.state.editPending?.ticket ||
                      this.state.savingTicket ||
                      (this.isVipPhotoRequired() &&
                        !this.state.editPending?.customer?.vipPhotoUrl &&
                        !this.state.vipPhoto)
                    }
                  >
                    {this.state.savingTicket ? 'SAVING...' : 'Set Machine'}
                  </Button>
                </div>

                <TextField
                  label="Comments"
                  multiline
                  rows={4}
                  variant="outlined"
                  value={this.state.editPending?.customer?.comments || ''}
                  InputProps={{
                    readOnly: true,
                  }}
                  className="comments-field"
                />

                <Button
                  className="btn-close"
                  variant="contained"
                  color="gray"
                  onClick={() => {
                    if (this.state.isMobile) {
                      this.setState({ isPreviewMobile: false });
                    } else {
                      this.setState({ isPreview: false });
                    }
                  }}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.page}>
            <div className={styles.canvas}>
              {/* Title row */}
              <div className={styles.titleRow}>
                <h1 className={styles.pageTitle}>Dashboard</h1>
                <button
                  className={styles.lastUpdatedBtn}
                  onClick={this.refreshComponent}
                  disabled={this.props.refreshing}
                  title="Refresh"
                  type="button"
                >
                  {this.props.refreshing ? (
                    <HourglassEmptyTwoTone style={{ fontSize: 16 }} />
                  ) : (
                    <RefreshIcon style={{ fontSize: 16 }} />
                  )}
                  <span>
                    Last updated:{' '}
                    {this.formatLastUpdated(this.state.lastUpdatedAt)}
                  </span>
                </button>
              </div>

              {/* KPI Bar */}
              <div className={styles.kpiBar}>
                <div className={styles.kpi}>
                  <div className={`${styles.kpiIcon} ${styles.kpiIconBlue}`}>
                    <People />
                  </div>
                  <div className={styles.kpiText}>
                    <span className={styles.kpiLabel}>Customers Today</span>
                    <span className={styles.kpiValue}>
                      {this.countCustomersToday()}
                    </span>
                  </div>
                </div>
                <div className={styles.kpiDivider} />
                <div className={styles.kpi}>
                  <div className={`${styles.kpiIcon} ${styles.kpiIconGreen}`}>
                    <AttachMoney />
                  </div>
                  <div className={styles.kpiText}>
                    <span className={styles.kpiLabel}>Total Match Amount</span>
                    <span className={styles.kpiValue}>
                      {this.formatTotalMatchAmount()}
                    </span>
                  </div>
                </div>
                <div className={styles.kpiDivider} />
                <div className={styles.kpi}>
                  <div className={`${styles.kpiIcon} ${styles.kpiIconIndigo}`}>
                    <Person />
                  </div>
                  <div className={styles.kpiText}>
                    <span className={styles.kpiLabel}>Employees Active</span>
                    <span className={styles.kpiValue}>
                      {this.countEmployeesActive()}
                    </span>
                  </div>
                </div>
              </div>

              {/* Customer List card */}
              {this.props.userInfo && this.props.customerPoints && (
                <div className={styles.listCard}>
                  <div className={styles.listHeader}>
                    <span className={styles.listTitle}>
                      Customer List ({combinedRows.length})
                    </span>
                    <div className={styles.listControls}>
                      <div className={styles.searchBox}>
                        <span className={styles.searchIcon}>
                          <SearchIcon style={{ fontSize: 18 }} />
                        </span>
                        <input
                          type="text"
                          className={styles.searchInput}
                          placeholder="Search customer..."
                          value={this.state.searchText}
                          onChange={this.handleSearchChange}
                        />
                      </div>
                      <div className={styles.filterPills}>
                        {[
                          { id: 'all', label: 'All' },
                          { id: 'pending', label: 'Pending' },
                          { id: 'matched', label: 'Matched' },
                        ].map((p) => (
                          <button
                            key={p.id}
                            type="button"
                            className={`${styles.filterPill} ${
                              this.state.activeFilter === p.id
                                ? styles.filterPillActive
                                : ''
                            }`}
                            onClick={this.setFilter(p.id)}
                          >
                            {p.label}
                          </button>
                        ))}
                      </div>
                      {!this.state.isMobile && (
                        <button
                          type="button"
                          className={styles.iconBtn}
                          title="View Report"
                          onClick={this.fetchPdf}
                        >
                          <People style={{ fontSize: 20 }} />
                        </button>
                      )}
                    </div>
                  </div>

                  <div className={styles.colHeader}>
                    <span className={styles.colLabel}>Customer</span>
                    <span className={`${styles.colLabel} ${styles.colCenter}`}>
                      Match Info
                    </span>
                    <span className={`${styles.colLabel} ${styles.colRight}`}>
                      Arrival Time
                    </span>
                  </div>

                  {combinedRows.length === 0 ? (
                    <div className={styles.emptyState}>
                      No customers to display.
                    </div>
                  ) : (
                    combinedRows.map((entry, idx) => {
                      const { kind, row } = entry;
                      const customer = row.customer || {};
                      const isPending = kind === 'pending';
                      const altClass =
                        !isPending && idx % 2 === 1 ? styles.rowAlt : '';
                      const rowClass = `${styles.row} ${
                        isPending ? styles.rowPending : altClass
                      }`;
                      const avatar = this.getAvatarUrl(customer);
                      const arrivalTime = Utils.convertTo12HourFormat(
                        row.signInTime || ''
                      );

                      let matchInfo;
                      if (isPending) {
                        matchInfo = (
                          <span className={styles.matchEmDash}>—</span>
                        );
                      } else {
                        const { employee, time } = this.parseFinalSignIn(
                          row.finalSignIn
                        );
                        matchInfo = (
                          <div className={styles.matchInfo}>
                            {row.ticket ? (
                              <span className={styles.matchPart}>
                                <span className={styles.matchIcon}>
                                  <DesktopWindows style={{ fontSize: 16 }} />
                                </span>
                                Machine {row.ticket}
                              </span>
                            ) : null}
                            {row.ticket && time ? (
                              <span className={styles.matchDot}>•</span>
                            ) : null}
                            {time ? (
                              <span className={styles.matchPart}>
                                <span className={styles.matchIcon}>
                                  <AccessTime style={{ fontSize: 16 }} />
                                </span>
                                {time}
                              </span>
                            ) : null}
                            {(row.ticket || time) && employee ? (
                              <span className={styles.matchDot}>•</span>
                            ) : null}
                            {employee ? (
                              <span>
                                By{' '}
                                <span className={styles.matchEmployee}>
                                  {employee}
                                </span>
                              </span>
                            ) : null}
                          </div>
                        );
                      }

                      return (
                        <div
                          key={`${kind}-${row.pendingId}`}
                          className={rowClass}
                          onClick={() =>
                            isPending
                              ? this.handleEditRow(row)
                              : this.handleEditPointsRow(row)
                          }
                        >
                          <div className={styles.customerCell}>
                            {avatar ? (
                              <img
                                src={avatar}
                                alt=""
                                className={styles.avatar}
                              />
                            ) : (
                              <div className={styles.avatarFallback}>
                                {this.getInitials(customer)}
                              </div>
                            )}
                            <div className={styles.nameWrap}>
                              <span className={styles.name}>
                                {customer.firstName} {customer.lastName}
                              </span>
                              {isPending && (
                                <span className={styles.pendingBadge}>
                                  Pending
                                </span>
                              )}
                            </div>
                          </div>
                          {matchInfo}
                          <div className={styles.arrivalCell}>
                            <span className={styles.arrivalLabel}>
                              Arrival Time
                            </span>
                            <span className={styles.arrivalRow}>
                              <span className={styles.arrivalValue}>
                                <span className={styles.arrivalIcon}>
                                  <AccessTime style={{ fontSize: 16 }} />
                                </span>
                                <span>{arrivalTime}</span>
                              </span>
                              {row.customer?.vipPhotoUrl && (
                                <button
                                  type="button"
                                  className={`${styles.rowDeleteBtn} ${styles.rowVipPhotoBtn}`}
                                  title="View VIP photo"
                                  aria-label="View VIP photo"
                                  onClick={this.openVipPhotoLightbox(
                                    row.customer.vipPhotoUrl
                                  )}
                                >
                                  <PhotoCameraIcon style={{ fontSize: 18 }} />
                                </button>
                              )}
                              <button
                                type="button"
                                className={styles.rowDeleteBtn}
                                title="Delete"
                                aria-label="Delete customer entry"
                                onClick={this.handleRowDelete(entry)}
                              >
                                <DeleteOutline style={{ fontSize: 18 }} />
                              </button>
                            </span>
                            {(row.customer?.vipPhotoUrl ||
                              this.canSeePoints()) && (
                              <span className={styles.metaRow}>
                                {row.customer?.vipPhotoUrl && (
                                  <button
                                    type="button"
                                    className={styles.vipPhotoBadge}
                                    title="View VIP photo"
                                    aria-label="View VIP photo"
                                    onClick={this.openVipPhotoLightbox(
                                      row.customer.vipPhotoUrl
                                    )}
                                  >
                                    <PhotoCameraIcon style={{ fontSize: 14 }} />
                                  </button>
                                )}
                                {this.canSeePoints() && (
                                  <span
                                    className={styles.pointsBadge}
                                    title="Customer points"
                                  >
                                    <span className={styles.pointsBadgeIcon}>
                                      <Stars style={{ fontSize: 14 }} />
                                    </span>
                                    <span className={styles.pointsBadgeValue}>
                                      {(
                                        Number(row.points ?? customer.points) ||
                                        0
                                      ).toLocaleString()}
                                    </span>
                                    <span className={styles.pointsBadgeUnit}>
                                      pts
                                    </span>
                                  </span>
                                )}
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    })
                  )}

                  <div className={styles.noteBar}>
                    <div className={styles.noteIcon}>i</div>
                    <div className={styles.noteText}>
                      <strong>NOTE:</strong>
                      Pending customers are shown at the top. The list is sorted
                      by arrival time (earliest to latest).
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {this.state.isCameraOpen && (
          <div className="camera-view-container">
            <video
              ref={this.videoRef}
              autoPlay
              playsInline
              muted
              className="video-ref"
            />
            <button
              type="button"
              onClick={this.stopCamera}
              className="camera-close-button"
              aria-label="Close Camera"
            >
              <CloseIcon />
            </button>
            <button
              type="button"
              onClick={this.capturePhoto}
              className="capture-button"
              aria-label="Capture Photo"
            >
              <span className="capture-icon"></span>
            </button>
            <button
              type="button"
              onClick={this.switchCamera}
              className="flip-camera-button"
              aria-label="Switch Camera"
            >
              <FlipCameraIosIcon />
            </button>
          </div>
        )}
        <canvas ref={this.canvasRef} style={{ display: 'none' }} />

        <Dialog
          open={Boolean(this.state.vipPhotoLightboxUrl)}
          onClose={this.closeVipPhotoLightbox}
          maxWidth="md"
          fullWidth
        >
          <DialogContent
            style={{
              padding: 0,
              background: '#000',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {this.state.vipPhotoLightboxUrl && (
              <img
                src={this.state.vipPhotoLightboxUrl}
                alt="VIP"
                style={{
                  maxWidth: '100%',
                  maxHeight: '85vh',
                  display: 'block',
                }}
              />
            )}
          </DialogContent>
          <DialogActions style={{ background: '#000' }}>
            <Button
              onClick={this.closeVipPhotoLightbox}
              style={{ color: '#fff' }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <SessionReportPdf
          type="points"
          userId={this.props.userInfo.userId}
          locationId={this.props.userInfo.selectedLocationId}
          locationName={this.props.userInfo.selectedLocationName}
          trigger={this.state.reportTrigger}
          onError={this.handleReportError}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  customerPending: pendingCustomerSelector(state),
  customerPoints: pointsCustomerSelector(state),
  refresh: refreshSelector(state),
  customerPointHistory: customerPointHistorySelector(state),
  onlineEmployees: onlineEmployeesSelector(state),
  rules: rulesSelector(state),
});

const actionCreators = {
  updateUserInfo,
  listCustomerPending,
  listCustomerPoints,
  setCustomerTicket,
  deleteCustomerPending,
  getPointHistory,
  getOnlineEmployees,
  listRules,
};

DashboardFinal.propTypes = {
  customerPending: PropTypes.array,
  customerPoints: PropTypes.array,
};

DashboardFinal.defaultProps = {
  customerPending: PropTypes.array,
  customerPoints: PropTypes.array,
};

export default withShipment(
  {
    mapStateToProps,
    actionCreators,
  },
  DashboardFinal
);
